import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const FlaskConical = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className='lucide lucide-flask-conical-icon lucide-flask-conical'
      >
        <path d='M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2' />
        <path d='M6.453 15h11.094' />
        <path d='M8.5 2h7' />
      </svg>
    </SvgIcon>
  );
};

export default FlaskConical;
